import { Controller } from '@hotwired/stimulus';
import { useEventListener } from 'stimulus-library/dist';

export default class extends Controller {
  static targets = ['button', 'menu'];

  connect() {
    useEventListener(this, this.buttonTarget, 'click', this.handleClick);
  }

  handleClick(e) {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }

    if (this.menuTarget.classList.contains('hidden')) {
      this.open();
    } else if (!this.menuTarget.classList.contains('hidden')) {
      this.close();
    }
  }

  open() {
    this.menuTarget.classList.remove('hidden');
    this.menuTarget.classList.remove('opacity-0');

    this.menuTarget.classList.add('opacity-100');

    const { teardown } = useEventListener(this, document.body, 'click', this.clickOutside);
    this.teardownClickOutsideListener = teardown;
  }

  close() {
    this.menuTarget.classList.add('hidden');
    this.menuTarget.classList.add('opacity-0');

    this.menuTarget.classList.remove('opacity-100');

    if (this.teardownClickOutsideListener) {
      this.teardownClickOutsideListener();
    }
  }

  clickOutside(e) {
    if (e.target !== this.buttonTarget && !this.buttonTarget.contains(e.target)) {
      this.close();
    }
  }
}
